import store from "../../../store"
import { CLIENT_STORE } from "../constants/other"

export default product_ids => product_ids.filter(
  product_or_id => store.state[CLIENT_STORE].products.some(
    ({ id: prod_id }) => prod_id === (product_or_id.id || product_or_id)
  )
)
